import { Route, Routes, BrowserRouter } from "react-router-dom";

import AdminLogin from "../Screens/Auth/Login";
import ForgetPassword from "../Screens/Auth/ForgetPassword";
import ForgetPassword2 from "../Screens/Auth/ForgetPassword2";
import ForgetPassword3 from "../Screens/Auth/ForgetPassword3";
import { Dashboard } from "../Screens/Dashboard";


import { UserManagement } from "../Screens/UserManagement";
import { UserDetail } from "../Screens/UserManagement/UserDetail";
import { AddUser } from "../Screens/UserManagement/AddUser";
import { EditUser } from "../Screens/UserManagement/EditUser";


import Profile from "../Screens/Profile";
import EditProfile from "../Screens/Profile/EditProfile";
import ChangePassword from "../Screens/Profile/ChangePassword";
import { ProtectedRoutes } from "./ProtectedRoutes";
import Error from "../Screens/Error";
import { MemberManagement } from "../Screens/MemberManagement";
import { AddMember } from "../Screens/MemberManagement/AddMember";
import { MemberDetail } from "../Screens/MemberManagement/MemberDetail";
import { EditMember } from "../Screens/MemberManagement/EditMember";
import { Orders } from "../Screens/Orders";
import { OrderDetail } from "../Screens/Orders/OrderDetail";
import Pricing from "../Screens/Pricing";
import SubscriptionManagement from "../Screens/SubscriptionManagement";
import RefundManagement from "../Screens/RefundManagement";
import useFirebaseMessaging from "../useFirebaseMessaging";
import { ReviewManagement } from "../Screens/ReviewManagement";
import { ReviewDetail } from "../Screens/ReviewManagement/ReviewDetail";
import { FAQManagement } from "../Screens/FAQManagement";
import TermsAndCondition from "../Screens/TermsandCondition";
import ContactQueriesManagement from "../Screens/ContactQueries/ContactQueriesManagement";
import PrivacyPolicy from "../Screens/PrivacyPolicy";

import RouteErrorBoundary from "../Components/RouteErrorBoundary/RouteErrorBoundary";
import ChildSafetyStandards from "../Screens/ChildSafety/Child";
import PdfMailSender from "../Screens/PdfMailSender";


export default function AdminRouter() {
  useFirebaseMessaging();

  return (
    <BrowserRouter>
      {/* <BrowserRouter basename="/harris-admin"> */}
      <RouteErrorBoundary>
        <Routes>
          {/* 🔐 AUTH ROUTES - Individual boundaries for isolation handled within AuthLayout */}
          <Route path="/" element={<AdminLogin />} />
          <Route path="/login" element={<AdminLogin />} />
          <Route path="/forget-password" element={<ForgetPassword />} />
          <Route path="/forget-password2" element={<ForgetPassword2 />} />
          <Route path="/forget-password3" element={<ForgetPassword3 />} />

          {/* 🛡️ PROTECTED ROUTES - Handled globally by the RouteErrorBoundary injected into DashboardLayout */}

          <Route path="/dashboard" element={<ProtectedRoutes Components={Dashboard} />} />

          <Route path="/user-management" element={<ProtectedRoutes Components={UserManagement} />} />
          <Route path="/user-detail/:id" element={<ProtectedRoutes Components={UserDetail} />} />
          <Route path="/add-user/" element={<ProtectedRoutes Components={AddUser} />} />
          <Route path="/edit-user/:id" element={<ProtectedRoutes Components={EditUser} />} />

          <Route path="/member-management" element={<ProtectedRoutes Components={MemberManagement} />} />
          <Route path="/add-member" element={<ProtectedRoutes Components={AddMember} />} />
          <Route path="/member-management/member-details/:id" element={<ProtectedRoutes Components={MemberDetail} />} />
          <Route path="/member-management/edit-member/:id" element={<ProtectedRoutes Components={EditMember} />} />

          <Route path="/orders" element={<ProtectedRoutes Components={Orders} />} />
          <Route path="/orders/:id" element={<ProtectedRoutes Components={OrderDetail} />} />

          <Route path="/pricing" element={<ProtectedRoutes Components={Pricing} />} />

          <Route path="/subscription-management" element={<ProtectedRoutes Components={SubscriptionManagement} />} />

          <Route path="/refunds" element={<ProtectedRoutes Components={RefundManagement} />} />

          <Route path="/profile" element={<ProtectedRoutes Components={Profile} />} />
          <Route path="/profile/edit-profile" element={<ProtectedRoutes Components={EditProfile} />} />
          <Route path="/profile/change-password" element={<ChangePassword />} />

          <Route path="/reviews" element={<ProtectedRoutes Components={ReviewManagement} />} />
          <Route path="/reviews/:id" element={<ProtectedRoutes Components={ReviewDetail} />} />

          <Route path="/faq" element={<ProtectedRoutes Components={FAQManagement} />} />

          <Route path="/terms" element={<ProtectedRoutes Components={TermsAndCondition} />} />

          <Route path="/contact-queries" element={<ProtectedRoutes Components={ContactQueriesManagement} />} />

          <Route path="/privacy-policy" element={<ProtectedRoutes Components={PrivacyPolicy} />} />

          <Route path="/child-safety" element={<ProtectedRoutes Components={ChildSafetyStandards} />} />

          <Route path="/pdf-mail-sender" element={<ProtectedRoutes Components={PdfMailSender} />} />

          {/* ❌ 404 Fallback */}
          <Route path="*" element={<Error />} />
        </Routes>
      </RouteErrorBoundary>
    </BrowserRouter>
  );
}